import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footer.cleaningService', 'Cleaning Service')}</h3>
            <p>{t('footer.professionalCleaning', 'Professional cleaning services you can trust')}</p>
          </div>
          <div className="footer-section">
            <h4>{t('footer.contactUs', 'Contact Us')}</h4>
            <p>{t('footer.email', 'Email')}: {t('footer.emails', 'Emails')}</p>
            <p>{t('footer.phone', 'Phone')}: {t('footer.phonenr', 'Phonenr')}</p>
          </div>
          <div className="footer-section">
            <h4>
              <Link to="/services" className="footer-link">{t('nav.services', 'Services')}</Link>
            </h4>
            <p>
              <Link to="/services/private-cleaning" className="footer-service-link">{t('footer.privateCleaning', 'Private Cleaning')}</Link>
            </p>
            <p>
              <Link to="/services/commercial-cleaning" className="footer-service-link">{t('footer.commercialCleaning', 'Commercial Cleaning')}</Link>
            </p>
            <p>
              <Link to="/services/move-in-move-out" className="footer-service-link">{t('footer.moveInMoveOut', 'Move-in/Move-out Cleaning')}</Link>
            </p>
          </div>
        
        </div>
        <div className="footer-bottom">
          <p>&copy; {(new Date().getFullYear())} {t('footer.cleaningService', 'Cleaning Service')}. {t('footer.allRightsReserved', 'All rights reserved.')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
